export const blockedCharacters = /[<>\\/;]/g;
const blockedSingleCharacter = /[<>\\/;]/;

export const sanitizeIllegalCharacters = (value: string | undefined) => {
  if (!value) return;
  return value.replaceAll(blockedCharacters, '');
};

export const blockIllegalCharacters = (value: string | undefined) => {
  if (!value) return false;

  if (blockedSingleCharacter.test(value)) return true;

  return false;
};
